import React, { Component } from 'react';
import { StatusBar, StatTypes, Period } from './StatusBar';
import { Server } from '../../services/Server';
import Loader from '../loader/Loader';
import { StatsInChartFormat } from '../../../../api/src/interfaces/shared';

interface Props {
  id?: string;
}

interface State {
  loaded: boolean;
  currentStats: StatsInChartFormat;
  historicStats: StatsInChartFormat;
  showStatsFor: StatTypes;
  period: Period;
  intervalId: number;
}

const defaultHistoricStats: StatsInChartFormat = {
  return: [],
  value: [],
  invested: []
};

const defaultCurrentStats: StatsInChartFormat = {
  ...defaultHistoricStats,
  annualPercentageReturn: 0
};

export default class UserStatus extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const intervalId = window.setInterval(this.periodicUpdate, 60000 * 3);
    this.state = {
      loaded: false,
      currentStats: defaultCurrentStats,
      historicStats: defaultHistoricStats,
      showStatsFor: 'return',
      period: 'month',
      intervalId
    };
    this.loadStats();
    window.onfocus = this.loadStats;
  }

  componentWillUnmount() {
    this.clearTimers();
  }

  clearTimers = () => {
    window.onfocus = () => {};
    window.clearInterval(this.state.intervalId);
  };

  loadStats = async () => {
    const { id } = this.props;
    const currentStats = await Server.getCurrentStats(id);
    const historicStats = await Server.getStats(id);
    if (!currentStats || !historicStats) this.clearTimers();
    this.setState({
      currentStats,
      historicStats,
      loaded: true
    });
  };

  periodicUpdate = () => {
    if (document.hasFocus()) {
      this.loadStats();
    }
  };

  changeStatsToShow = (showStatsFor: StatTypes) => {
    this.setState({
      showStatsFor
    });
  };

  changePeriod = (period: Period) => {
    this.setState({ period });
  };

  render() {
    const { showStatsFor, period } = this.state;
    return this.state.loaded ? (
      <div>
        <div className="status-options">
          <div>
            <span
              className={showStatsFor === 'value' ? 'active' : undefined}
              onClick={() => this.changeStatsToShow('value')}
            >
              Verdi
            </span>
            <span
              className={showStatsFor === 'return' ? 'active' : undefined}
              onClick={() => this.changeStatsToShow('return')}
            >
              Avkastning
            </span>
          </div>
          <div>
            <span
              className={period === 'day' ? 'active' : undefined}
              onClick={() => this.changePeriod('day')}
            >
              Dag
            </span>
            <span
              className={period === 'week' ? 'active' : undefined}
              onClick={() => this.changePeriod('week')}
            >
              Uke
            </span>
            <span
              className={period === 'month' ? 'active' : undefined}
              onClick={() => this.changePeriod('month')}
            >
              Mnd
            </span>
            <span
              className={period === 'year' ? 'active' : undefined}
              onClick={() => this.changePeriod('year')}
            >
              År
            </span>
          </div>
        </div>
        <StatusBar
          labelType={showStatsFor}
          currentStats={this.state.currentStats[showStatsFor]}
          historicStats={this.state.historicStats[showStatsFor]}
          period={this.state.period}
          annualPercentageReturn={
            this.state.currentStats.annualPercentageReturn
          }
        />
      </div>
    ) : (
      <Loader />
    );
  }
}
